import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ArrowRight, Lock } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/hooks/useAuth";

export default function SetupPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const { setUser } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!token) { setErr("Missing setup token."); return; }
    api(`/auth/setup-token/${token}`).then(setInfo).catch(e => setErr(e.message));
  }, [token]);

  const submit = async e => {
    e.preventDefault();
    if (pw !== pw2) return setErr("Passwords do not match.");
    setBusy(true); setErr("");
    try { const u = await api("/auth/setup-password", { method: "POST", body: JSON.stringify({ token, password: pw }) }); setUser(u); nav("/account", { replace: true }); }
    catch (ex) { setErr(ex.message); }
    finally { setBusy(false); }
  };

  return (
    <main className="login-page">
      <div className="login-panel wide">
        <span className="brand-mark">D</span>
        <span className="eyebrow">Member account</span>
        <h1>Choose your <span className="gold-text">password.</span></h1>
        {info && <p data-testid="setup-info">Setting up the account for <b>{info.name}</b> ({info.email}).</p>}
        {err && <div className="error-message" data-testid="setup-error">{err}</div>}
        {info && (
          <form className="auth-form" onSubmit={submit} data-testid="setup-password-form">
            <label>New password<div className="input-icon"><Lock size={15} /><input type="password" required minLength={8} value={pw} onChange={e => setPw(e.target.value)} data-testid="setup-password-input" /></div></label>
            <label>Confirm password<div className="input-icon"><Lock size={15} /><input type="password" required minLength={8} value={pw2} onChange={e => setPw2(e.target.value)} data-testid="setup-password-confirm" /></div></label>
            <button className="button button-gold" disabled={busy} data-testid="setup-password-submit">{busy ? "Saving…" : "Save & open dashboard"} <ArrowRight size={15} /></button>
          </form>
        )}
        <Link to="/login" data-testid="setup-login-link">Back to sign in</Link>
      </div>
    </main>
  );
}
